import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { webSocketService } from '@/services/websocket';

// Component to manage WebSocket connection for chat
export const ChatManager: React.FC = () => {
  const { token, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !token) {
      // Disconnect if not authenticated
      if (webSocketService.isConnected()) {
        webSocketService.disconnect();
      }
      return;
    }

    // Connect to chat WebSocket if not already connected
    if (!webSocketService.isConnected()) {
      console.log('🔗 Connecting to chat WebSocket...');
      webSocketService.connect(token).catch((error) => {
        console.error('❌ Failed to connect to chat WebSocket:', error);
      });
    }

    // Cleanup function
    return () => {
      // Only disconnect if component is unmounting due to logout
      // In practice, we want to keep the connection alive for the entire session
    };
  }, [token, isAuthenticated]);

  return null; // This component doesn't render anything
};